import Cookies from 'js-cookie';

import {getState, setState} from './state';

export const COOKIE_NAME = 'filterByMapBounds';

export class FilterByMapBoundsControl {

  constructor(selector) {
    if(mapSupport.isListDriven) {
      $('.filterByMapBoundsWrapper').remove();
      return;
    }
    this.element = $('#filterByMapBounds');
    this.wrapper = $('.filterByMapBoundsWrapper');

    this.init();
  }

  init() {

    this._restoreState();
    this._bindControlChanges();
    this._bindStateChanges();

  }

  _restoreState() {
    if(getState('filterByMapBounds')){
      //this.element.attr('checked', 'checked');
      return false;
    }
  }

  _bindControlChanges() {
    this.element.change(() => {
      //setState('filterByMapBounds', this.element.prop('checked'));
      setState('filterByMapBounds', false);
    });
  }

  _bindStateChanges() {

    window.addEventListener('stateChange:mobileSearchResultsView', (e) => {
      if(e.detail.newValue === 'map') {

        // when the mobile map is shown, we only want to change the filterByMapBounds
        // checkbox if the user did not previously have an explicit state set
        if(typeof getState('filterByMapBounds') === 'undefined') {
          setState('filterByMapBounds', false);
        }
      }
    });

    window.addEventListener('stateChange:desktopSearchResultsView', (e) => {
      if(e.detail.newValue === 'split') {
        
        // when the mobile map is shown, we only want to change the filterByMapBounds
        // checkbox if the user did not previously have an explicit state set
        if(typeof getState('filterByMapBounds') === 'undefined') {
          setState('filterByMapBounds', false);
        }        
      }
    });

    window.addEventListener('stateChange:filterByMapBounds', (e) => {
      Cookies.set(COOKIE_NAME, e.detail.newValue);
      if(e.detail.newValue){
        this.element.attr('checked', 'checked');
      } else {
        this.element.removeAttr('checked');
      }
    });

  }
}
